import PropTypes from 'prop-types'
import React, { Component } from 'react'
import isEmpty from 'lodash/isEmpty'

import Modal from 'base/react/components/modal'
import GiftcardForm from 'desktop/components/forms/giftcard_form'
import Validate from 'base/lib/validate'

const getErrorsForGiftCardData = data => {
  const validations = {
    recipientName: {
      value: data.recipientName,
      validations: {
        presence: true,
      },
    },
    recipientEmail: {
      value: data.recipientEmail,
      validations: {
        presence: true,
        pattern: 'email',
      },
    },
    deliveryDate: {
      value: data.deliveryDate,
      validations: {
        presence: true,
      },
    },
  }

  const validator = new Validate({ verboseErrors: false })
  validator.validate(validations)
  return validator.getErrors()
}

class GiftcardModal extends Component {
  static propTypes = {
    onRequestClose: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
    presetValues: PropTypes.object,
  }

  state = {
    errors: false,
  }

  handleSubmit = giftcardData => {
    this.setState({
      errors: {},
    })
    const errors = getErrorsForGiftCardData(giftcardData)
    if (!isEmpty(errors)) {
      this.setState({ errors })
    } else {
      this.props.onSubmit(giftcardData)
    }
  }

  render() {
    return (
      <Modal onRequestClose={this.props.onRequestClose} minHeight="auto">
        <div className="giftcard-reservation">
          <h2 className="giftcard-reservation__header">
            {this.props.presetValues?.amount
              ? `Digital Gift Card — $${parseInt(this.props.presetValues?.amount, 10)}`
              : "Who's the lucky recipient?"}
          </h2>
          <GiftcardForm
            isLoading={this.props.isLoading}
            onSubmit={this.handleSubmit}
            errors={this.state.errors}
            presetValues={this.props.presetValues}
          />
        </div>
      </Modal>
    )
  }
}

export default GiftcardModal
